import { render, staticRenderFns } from "./LeaveBalanceTable.vue?vue&type=template&id=12f772dd&"
import script from "./LeaveBalanceTable.vue?vue&type=script&lang=js&"
export * from "./LeaveBalanceTable.vue?vue&type=script&lang=js&"
import style0 from "./LeaveBalanceTable.vue?vue&type=style&index=0&id=12f772dd&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports